import client from "./client";

export const cheersApi = {
  random: (event = "release") => client.get(`/cheers/random?event=${event}`),
  list:   (event)             => client.get(event ? `/cheers?event=${event}` : "/cheers"),
  create: (event_type, text)  => client.post("/cheers", { event_type, text }),
  delete: (id)                => client.delete(`/cheers/${id}`),
};
